var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobsIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F2F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0952 19.6126H19.9126C19.2826 19.6126 18.78 19.1099 18.78 18.48C18.78 17.85 19.2826 17.3477 19.9126 17.3477H28.0952C28.7173 17.3477 29.2274 17.85 29.2274 18.48C29.2274 19.1099 28.7173 19.6126 28.0952 19.6126ZM39.75 15.2552H8.24996C7.01236 15.2552 6 16.2602 6 17.5052V39.7501C6 40.9951 7.01236 42 8.24996 42H39.75C40.9951 42 42 40.9951 42 39.7501V17.5052C42 16.2602 40.9951 15.2552 39.75 15.2552Z",
    fill: "#00468A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00195 21.7067V39.0005H39.0023V21.7067H9.00195Z",
    fill: "#F6F6F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4959 27.3744C19.4959 28.8146 18.3285 29.9819 16.8888 29.9819C15.4486 29.9819 14.2812 28.8146 14.2812 27.3744C14.2812 25.9343 15.4486 24.7669 16.8888 24.7669C18.3285 24.7669 19.4959 25.9343 19.4959 27.3744Z",
    fill: "#3D5469"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7738 35.9404C21.6993 33.3038 19.5434 31.1883 16.889 31.1883C14.2343 31.1883 12.0784 33.3038 12.0039 35.9404H21.7738Z",
    fill: "#3D5469"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1504 29.2594V31.3877H36.0038V29.2594H23.1504Z",
    fill: "#D1D8E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1504 33.8118V35.9404H36.0038V33.8118H23.1504Z",
    fill: "#D1D8E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.622 6C26.7266 6 27.622 6.89543 27.622 8V17.3551C27.622 17.9776 27.1197 18.4799 26.4972 18.4799H21.5096C20.887 18.4799 20.3848 17.9776 20.3848 17.3551V8C20.3848 6.89543 21.2802 6 22.3848 6H25.622Z",
    fill: "#D74F58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsIdCard);
export default __webpack_public_path__ + "static/media/jobs_id_card.1ca1841880fe29bf648010d60f2684c9.svg";
export { ForwardRef as ReactComponent };